import { formatTimestampHuman } from "../date-utils";
export const activityDtoFields = [{
        name: "stato",
        title: "Stato",
        render: (record) => record.state == null || record.state == "" ? "" : `<span class="tag ${record.state == 'Completato' ? 'is-success' : 'is-info'}">${record.state}</span>`
    }, {
        name: "type",
        title: "Tipo",
        render: (record) => record.entityType == "Contact" ? "Contatto" : record.entityType == "Company" ? "Cliente" : "Lead"
    }, {
        name: "per",
        title: "Per",
        render: (record) => record.entityName
    }, {
        name: "oggetto",
        title: "Oggetto",
        render: (record) => record.activity.subject
    }, {
        name: "assigned",
        title: "Assegnato a",
        render: (record) => record.assignedUser == null ? "" : record.assignedUser
    }, {
        name: "nota",
        title: "Nota",
        render: (record) => record.activity.commentText == null ? "" : record.activity.commentText
    }, {
        name: "noteOnCompletition",
        title: "Nota completamento",
        render: (record) => record.activity.noteOnCompletition == null ? "" : record.activity.noteOnCompletition
    }, {
        name: "createdOn",
        title: "Data Creazione",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatTimestampHuman(record.activity.createdOn)
    }, {
        name: "doneDate",
        title: "Data Completamento",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatTimestampHuman(record.activity.doneDate)
    }, {
        name: "created",
        title: "Creato da",
        render: (record) => record.creatorUser
    }];
